var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:`e-button${this.type}`,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.baseButtonClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }